// ============================================================================
// DFS TOPOLOGICAL SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'dfs-topological',
  name: 'DFS Topological Sort',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'A topological sorting algorithm using DFS that produces a linear ordering of vertices in a directed acyclic graph (DAG) such that for every directed edge (u, v), vertex u comes before v in the ordering.'
};
